import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { GradeService } from '../../shared/services/grade.service';
import { ProgramService } from '../../shared/services/program.service';
import { Program } from 'src/app/shared/class/program';

@Component({
  selector: 'app-grade',
  templateUrl: './grade.component.html',
  styleUrls: ['./grade.component.css']
})

export class GradeComponent implements OnInit {
  gradeForm:FormGroup;
  httpResponseMessage:any;
  submitted=false;
  post:any;
  programs:any;
  gradeentity:any;
  PK_GradeID:any='';
  FK_ProgramID:any='';
  Grade:any='';
  GradePoint:string='';
  GradeMin:string='';
  GradeMax:string='';
  GradeDesc:string='';
  errorMessage: String='';
  buttonTitle:String =  'S A V E ';
  newtitle:String =" N E W ";
  selectedProgram:Program = new Program (1,'ABC','asd','sadasdsa');
  
  constructor(
    private FormBuilder:FormBuilder, 
    private _gradeservice:GradeService,
    private _programservice:ProgramService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.gradeForm = this.FormBuilder.group({
      'PK_GradeID':['', ],
      'FK_ProgramID':['',],
      'Grade':['', Validators.required],
      'GradePoint':['', Validators.required],
      'GradeMin':['', Validators.required],
      'GradeMax':['', Validators.required],
      'GradeDesc':['', Validators.required],
    })

    this.getAllProgram();
  }

postGrade(post) :void  {
    if(post.PK_GradeID!='' && post.PK_GradeID!=null) {
      this.updateGrade(post);
    }
    else{
     this.createGrade(post);
    }
  }

  
cleardata()
{
  this.gradeForm.reset();
}

  getAllProgram() :void  {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
      data => {
           this.programs=data;
      },
      error => this.errorMessage = <any>error)
    }

  createGrade(post) :void  {
    this.submitted=true;
    if (this.gradeForm.invalid) {  return;  }
    this.post=JSON.stringify(post);

    this._gradeservice.postGrade(AppSettings.API_ENDPOINT+AppSettings.CreateGrade,this.post).subscribe(
    data =>{   
      this.httpResponseMessage=data
      this.openSnackBar(this.httpResponseMessage,'');
      this.gradeForm.reset();
    },
    error => this.errorMessage = <any>error)
}


  updateGrade(post)  {
    if (this.gradeForm.invalid) {  return;  }
    this.post=JSON.stringify(post);
    this._gradeservice.updateGrade(AppSettings.API_ENDPOINT+AppSettings.UpdateGrade,this.post).subscribe(
      data =>{   
        this.httpResponseMessage=data
        this.openSnackBar(this.httpResponseMessage,'');
        this.gradeForm.reset();
      },
      error => this.errorMessage = <any>error)
  }


  receiveData($event) {
    this.gradeentity = $event
    this.PK_GradeID=this.gradeentity[0].PK_GradeID;
    this.FK_ProgramID=this.gradeentity[0].FK_ProgramID;
    this.Grade=(this.gradeentity[0].Grade).trim();
    this.GradePoint=(this.gradeentity[0].GradePoint);
    this.GradeMin=(this.gradeentity[0].GradeMin);
    this.GradeMax=(this.gradeentity[0].GradeMax);
    this.GradeDesc=(this.gradeentity[0].GradeDesc);
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message,action ,{
      duration: 2000,
      verticalPosition: 'bottom'
    });
    }
}